import { createContext, useContext } from 'react';

const SidebarContext = createContext<{
  collapsed: boolean;
  maxContentHeight: number;

  // setters
  setCollapseBehavior: (collapseBehavior: 'full' | 'vertical-only' | 'none') => void;
  setContentHeight: (height: number) => void;
  setFooterHeight: (height: number) => void;
  setFullHeight: (fullHeight: boolean) => void;
  setPreventHeightRecalculation: (preventHeightRecalculation: boolean) => void;
  setTitleHeight: (height: number) => void;
  toggleCollapse: () => void;
}>({
  collapsed: false,
  maxContentHeight: 0,
  setCollapseBehavior: () => {},
  setContentHeight: () => {},
  setFooterHeight: () => {},
  setFullHeight: () => {},
  setPreventHeightRecalculation: () => {},
  setTitleHeight: () => {},
  toggleCollapse: () => {}
});

export const SidebarProvider = ({
  children,
  collapsed,
  maxContentHeight,
  setCollapseBehavior,
  setContentHeight,
  setFooterHeight,
  setFullHeight,
  setPreventHeightRecalculation,
  setTitleHeight,
  toggleCollapse
}) => {
  return (
    <SidebarContext.Provider
      value={{
        collapsed,
        maxContentHeight,
        setCollapseBehavior,
        setContentHeight,
        setFooterHeight,
        setFullHeight,
        setPreventHeightRecalculation,
        setTitleHeight,
        toggleCollapse
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebarContext = () => useContext(SidebarContext);
